export enum SignupType {
    REZDY_BOOKING_SOFTWARE = 'REZDY_BOOKING_SOFTWARE',
    REZDY_MARKETPLACE = 'REZDY_MARKETPLACE',
}
